/**
 * 会员信息
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//基本信息编辑
import AuctionMemberEdit from './AuctionMemberEdit';
//商户下属用户维护
import MemberTeam from '../member/MemberTeam';
//详情
import MemberDetail from '../member/MemberDetail';
//保证金充值
import MemberBondRecharge from '../member/MemberBondRecharge';
//保证金退款
import MemberBondRefund from '../member/MemberBondRefund';
//保证金口矿
import MemberBondDeduction from '../member/MemberBondDeduction';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth'

class MemberIndex extends React.Component {

    columns = [{
        title: '会员名称',
        dataIndex: 'name',
        width: '14%',
    }, {
        title: '证件号码',
        dataIndex: 'creditNo',
        width: '14%',
    }, {
        title: '地址',
        dataIndex: 'address',
        width: '20%',
    }, {
        title: '联系人',
        dataIndex: 'contactMan',
        width: '7%',
    }, {
        title: '联系电话',
        dataIndex: 'contactNumber',
        width: '10%',
    }, {
        title: '可用保证金',
        dataIndex: 'auctionBondFree',
        width: '7%',
    }, {
        title: '冻结保证金',
        dataIndex: 'auctionBondFreeze',
        width: '7%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("AUCTION_MEMBER_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AUCTION_MEMBER_MEMBER")?
                <Tooltip title="会员下用户配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AUCTION_MEMBER_BOND_RECHARGE")?
                <Tooltip title="保证金充值">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doBondRecharge.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AUCTION_MEMBER_BOND_REFUND")?
                <Tooltip title="保证金退款">
                    <Icon type="pay-circle" theme="filled" className="table-operate-icon" onClick={this.doBondRefund.bind(this, record)} />
                </Tooltip>
                :""}
                {/* <Tooltip title="保证金扣款">
                    <Icon type="transaction" className="table-operate-icon" onClick={this.doBondDeduction.bind(this, record)} />
                </Tooltip> */}
                <Tooltip title="明细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {
            auction: 1,    //只查询竞价会员
            state: 0,
        },
        teamVisible: false, //会员下用户绑定
        detailVisible: false,   //详情
        rechargeBondVisible: false, //保证金充值
        refundBondVisible: false, //保证金退款
        deductionBondVisible: false, //保证金扣款
        summary: {},
    };

    add = () => {
        this.setState({ editData: {}, visible: true });
    }

    update = (info, e) => {
        http.get({
            url: "/auctionMember/findAuctionMemberInfo",
            data: { memberCode: info.code },
            success: (res) => {
                this.state.initEdit(res);
                this.setState({ editData: info, visible: true });
            }
        })
    }

    //会员下的人员设置
    updateTeam = (info, e) => {
        this.refs["memberTeam"].initData(info.code,
            (res) => { this.setState({ editData: info, teamVisible: true }) }
        );
    }

    //充值
    doBondRecharge = (info, e) => {
        info["bond"] = info["auctionBond"];
        info["bondFree"] = info["auctionBondFree"];
        info["bondFreeze"] = info["auctionBondFreeze"];
        this.setState({ editData: info, rechargeBondVisible: true });
    }

    //保证金退款
    doBondRefund = (info, e) => {
        info["bond"] = info["auctionBond"];
        info["bondFree"] = info["auctionBondFree"];
        info["bondFreeze"] = info["auctionBondFreeze"];
        this.setState({ editData: info, refundBondVisible: true });
    }

    //保证金扣款
    doBondDeduction = (info, e) => {
        info["bond"] = info["auctionBond"];
        info["bondFree"] = info["auctionBondFree"];
        info["bondFreeze"] = info["auctionBondFreeze"];
        this.setState({ editData: info, deductionBondVisible: true });
    }

    //详情
    detail = (info, e) => {
        //查询当前账户的汇总信息
        http.post({
            url: '/auctionMember/findAccountRecordSummary',
            data: { memberCode: info.code },
            success: (res) => {
                this.setState({ summary: res, editData: info, detailVisible: true });
                this.refs["detail"].loadTableData(info.code, "account");
                this.refs["detail"].loadTableData(info.code, "bond");
            }
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400 }}
                                />
                                <OrgSelect style={{ width: '200px', marginLeft: "10px" }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("AUCTION_MEMBER_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/auctionMember/findMemberPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                    initParams={this.state.queryData}
                />
                <AuctionMemberEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    initEdit={(func) => { this.setState({ initEdit: func }) }}
                />
                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="auctionMember"
                />
                <MemberDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    summary={this.state.summary}
                    ref="detail"
                    content="auctionMember"
                />
                <MemberBondRecharge
                    visible={this.state.rechargeBondVisible}
                    onCancel={() => { this.setState({ rechargeBondVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="auctionMember"
                    business="auction"
                />
                <MemberBondRefund
                    visible={this.state.refundBondVisible}
                    onCancel={() => { this.setState({ refundBondVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="auctionMember"
                    business="auction"
                />
                <MemberBondDeduction
                    visible={this.state.deductionBondVisible}
                    onCancel={() => { this.setState({ deductionBondVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="auctionMember"
                    business="auction"
                />
            </div>
        )
    }
}

export default MemberIndex;